"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_1 = require("./styled");
const google_play_logo_png_1 = __importDefault(require("../../../../../static/downloads/google-play-logo.png"));
const apple_logo_png_1 = __importDefault(require("../../../../../static/downloads/apple-logo.png"));
const StoreToggle = ({ selectedStore, setSelectedStore }) => {
    return (react_1.default.createElement(styled_1.ToggleWrapper, null,
        react_1.default.createElement(styled_1.OptionButton, { selected: selectedStore === "GOOGLE_PLAY", onClick: () => setSelectedStore("GOOGLE_PLAY") },
            react_1.default.createElement("input", { type: "radio", value: "GOOGLE_PLAY", name: "selectedStore", defaultChecked: true }),
            react_1.default.createElement("img", { src: google_play_logo_png_1.default, alt: "google-play" }),
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.qrcodeModal-android-title", tagName: "span" })),
        react_1.default.createElement(styled_1.OptionButton, { selected: selectedStore === "APP_STORE", onClick: () => setSelectedStore("APP_STORE") },
            react_1.default.createElement("input", { type: "radio", value: "APP_STORE", name: "selectedStore" }),
            react_1.default.createElement("img", { src: apple_logo_png_1.default, alt: "app-store" }),
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "buy.qrcodeModal-apple-title", tagName: "span" }))));
};
exports.default = StoreToggle;
//# sourceMappingURL=StoreToggle.js.map